import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import React from 'react'

import Footer from '@src/components/Footer'
import Header from '@src/components/Header'

interface OpponentPageProps {
  children: React.ReactNode
}

const OpponentPage = ({ children }: OpponentPageProps): JSX.Element => {
  return (
    <Container
      id={'rootContainer'}
      lang={'fi'}
      sx={{
        margin: 'auto',
        padding: 0,
        display: 'grid',
        gridTemplateRows: 'auto 1fr auto',
        height: '100vh',
      }}
    >
      <Header />
      <Box component={'main'} sx={{ backgroundColor: 'grey.100' }}>
        {children}
      </Box>

      <Footer />
    </Container>
  )
}

export default OpponentPage
